import { type Document } from '@store/skeletor/documents/types';

const getDocumentBalance = ({
  documentAmount,
  documentPayment,
}: Pick<Document, 'documentAmount' | 'documentPayment'>) => {
  const balance = Number(documentAmount) - Number(documentPayment);
  if (balance < 0) return 0;

  return balance;
};

export { getDocumentBalance };
